<template>
  <div class="product_tab_1 outer_tab">
    <!--收起内容-->
    <div class="pulldownbox info-container" v-show="!showQueryFilter">
      <i class="el-icon-info"></i>
      <span>查询条件</span>
      <span class="pulldownbtn" @click="pulldown"
        >展开<i class="el-icon-arrow-down"></i
      ></span>
    </div>
    <!--展开内容-->
    <div
      style="width: 100%"
      class="expandbox info-container"
      v-show="showQueryFilter"
    >
      <el-form
        class="product_filter_form"
        :model="filterForm"
        inline
        ref="filterForm"
        size="small"
        label-width="100px"
      >
        <el-form-item label="选择区域:" prop="qhdm">
          <!--县乡村 联动-->
          <el-cascader
            style="height: 40px"
            class="textInput"
            v-model="filterForm.qhdmValue"
            :options="areaOptions"
            :props="areaProps"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="主体类型:" prop="enterpriseTypeNumber">
          <el-select
            v-model="filterForm.enterpriseTypeNumber"
            placeholder="请选择主体类型"
          >
            <el-option
              v-for="item in industryOptions"
              :key="item.dicId"
              :label="item.dicName"
              :value="item.dicId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营类型:" prop="industryDicNumber">
          <el-cascader
            style="height: 40px"
            class="textInput"
            v-model="filterForm.industryDicNumber"
            :options="industryList"
            :props="industryProps"

          ></el-cascader>
        </el-form-item>
        <br />
        <el-form-item label="主体名称:" prop="enterpriseName">
          <el-input
            class="textInput"
            v-model="filterForm.enterpriseName"
            placeholder="请输入主体名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" prop="contacts">
          <el-input
            class="textInput"
            v-model="filterForm.contacts"
            placeholder="请输入法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="成立日期:" prop="submitDate" class="small-input">
          <el-date-picker
            v-model="filterForm.submitDate"
            style="width: 250px"
            type="daterange"
            value-format="timestamp"
            unlink-panels
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
         <br />
         <el-form-item label="主体等级:" prop="dicNumber">
          <el-select
            v-model="filterForm.dicNumber"
            placeholder="请选择主体等级"
          >
            <el-option
              v-for="item in listOptions"
              :key="item.dicNumber"
              :label="item.dicName"
              :value="item.dicNumber"
            ></el-option>
          </el-select>
         </el-form-item>
         <el-form-item label="审核状态:" prop="status">
         <el-select
            v-model="filterForm.status"
            placeholder="请选择审核状态"
          >
            <el-option
              v-for="item in statusList"
              :key="item.status"
              :label="item.label"
              :value="item.status"
            ></el-option>
          </el-select>
         </el-form-item>

      </el-form>
      <el-row style="text-align: center; margin: 5px 0">
        <el-button @click="queryBtnClick" type="primary" size="small"
          >查询</el-button
        >
        <el-button @click="resetFilter" type="primary" plain size="small"
          >重置</el-button
        >
        <span class="pullupbtn" @click="pullup"
          >收起<i class="el-icon-arrow-up"></i
        ></span>
      </el-row>
    </div>
    <div
      style="height: 100%; position: relative"
      class="tablebox info-container"
    >
     <!--总计内容-->
      <el-row class="count_content">
        <i class="el-icon-success icon-table-summary"></i>
        <span
          >共查询到
          <span class="count_number">{{ totalItems }}</span> 条数据</span
        >
        快速筛选
      </el-row>
      <div style="display: flex;">
        <div class="box_total" :class="{bg:tims==1}" @click="clicktotalItems(1)">
          <div>已认证</div>
          <div>{{successCount}}个</div>
        </div>
        <!-- <div class="box_total" :class="{bg:tims==2}" @click="clicktotalItems(2)">
          <div>待初审</div>
          <div>{{townCheckCount}}个</div>
        </div>
        <div class="box_total" :class="{bg:tims==3}" @click="clicktotalItems(3)">
          <div>待复审</div>
          <div>{{countyCheckCount}}个</div>
        </div> -->
        <div class="box_total" :class="{bg:tims==4}" @click="clicktotalItems(4)">
          <div>全部</div>

        </div>
      </div>


      <!--table-->
      <div style="height: 100%; position: relative">
        <el-table
          class="product_tab_1_table"
          :data="tableData"
          ref="dataTable"
          @current-change="handleCurrentChange"
          height="100%"
          highlight-current-row
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="qhmc"
            label="区划"
            min-width="30"
            :formatter="formatterFn"
          ></el-table-column
          ><el-table-column
            prop="enterpriseName"
            label="主体名称"
            min-width="30"
            :formatter="formatterFn"
          >
              <template slot-scope="scope">

                <span>{{scope.row.enterpriseName}}</span>
                <img  v-if="scope.row.officialStatus==2"  :src="gstbImg" alt="" style="width: 30px;height: 30px;vertical-align: middle;">
              </template>
          </el-table-column>
          <el-table-column
            prop="enterpriseTypeName"
            label="主体类型"
            min-width="30"
          >
          </el-table-column>
          <el-table-column
            prop="industryDicName"
            label="经营类型"
            min-width="25"
            :show-overflow-tooltip="true"
            :formatter="formatterFn"
          >
            <template slot-scope="scope">
                <span>{{scope.row.industryDicName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="corporationName"
            label="法人姓名"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="gradeName"
            label="主体等级"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="createDate"
            label="成立时间"
            min-width="25"
            :formatter="formatterDate"
          ></el-table-column>
          <el-table-column
            prop="successTime"
            label="入库时间"
            min-width="25"
            :formatter="formatterDate"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="审核状态"
            min-width="25"
            :formatter="formatterFn"
          >
          <template slot-scope="scope" >
              <span v-if="scope.row.status==1">审核通过</span>
              <span v-if="scope.row.status==2">黑名单</span>
              <span v-if="scope.row.status==3">已创建</span>
              <span v-if="scope.row.status==4">待初审</span>
              <span v-if="scope.row.status==5">驳回</span>
              <span v-if="scope.row.status==6">异常</span>
              <span v-if="scope.row.status==7">注销</span>
              <span v-if="scope.row.status==8">待复审</span>
          </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope" >
              <div class="template-slot-scope">
                  <el-tooltip class="item" content="异常" placement="top" v-if="scope.row.status==1">
                    <i
                      class="table-icon el-icon-warning-outline"
                      @click="abnormal(scope.row)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip class="item" content="注销" placement="top" v-if="scope.row.status==1">
                    <i
                      class="iconfont icon-zhuxiao"
                      @click="cancellation(scope.row)"
                      ></i>
                  </el-tooltip>
                  <el-tooltip class="item" content="详情" placement="top">
                    <i
                      class="table-icon el-icon-document"
                      @click="searchDialog(scope.row)"
                    ></i>
                  </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页工具-->
      <el-row class="page-row">
        <el-pagination
          background
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="currentChange"
          layout="prev, pager, next, jumper"
          :total="totalItems"
        >
        </el-pagination>
      </el-row>
    </div>
    <detail-dialog
      :ifAbnormal="ifAbnormal"
       :ifAudit="ifAudit"
      :ifRejected="false"
      @tableRefresh="priseList"
      ref="show_operator_dialog"
    ></detail-dialog>
    <el-dialog :visible.sync="showDetailDialog" :title="Title" width="35%">
      <h3 v-if="difference==true" style="text-align: center;">确定将该主体加入 <span style="color:#F59A23">异常主体</span>  ？</h3>
      <h3 v-else style="text-align: center;">确定将该主体加入 <span style="color:#D9001B;">注销主体</span>  ？</h3>
      <!-- <h3  style="text-align: center;">确定将该主体移出 <span style="color:#F59A23;">注销主体</span>，恢复名录库管理 ？ </h3> -->
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="determine"
          >确 定</el-button>
        <el-button size="small" plain type="primary" @click="showDetailDialog = false"
          >取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import detailDialog from "./detailDialog";
import API from "@/api/serviceOrgManagement/api_userManagement";
import gstbImg from '../../../../static/img/gstb.png'
export default {
  components: {
    detailDialog,
  },
  name: "contract-list",
  data() {
    return {

      //区域参数
      areaOptions: [],
      tims:4,
      ifAbnormal:false,//审核通过,
      ifAudit:false,//待审核
      gstbImg:gstbImg,
      areaProps: {
        label: "qhmc",
        value: "qhdm",
        children: "children",
        checkStrictly: true,
      },
      industryProps: {
        label: "dicName",
        value: "dicNumber",
        children:"child",
        checkStrictly: true
      },
      filterForm: {
        qhdmValue: [Cookies.get("curAreaCode")], // 区域
        enterpriseName: "", // 主体名称
        enterpriseTypeNumber: "", // 主体类型
        industryDicNumber: "", // 所属行业名称
        contacts: "", // 法人姓名
        submitDate:[], // 日期
        status:'',//审核状态
        dicNumber:""//主体等级
      },
      submitOptions: [
        { label: "是", number: 1 },
        { label: "否", number: 0 },
      ],
      currentPage: 1 /*分页工具当前选中页*/,
      pageSize: 10,
      totalItems: 0 /*数据总条数*/,
      showQueryFilter: true /*是否显示搜索条件*/,
      currentRow: "" /*当前选中的table行*/,
      tableData: [] /*table数据源*/,
      params: {}, // 查询参数
      industryOptions: [], //主体类型列表
      industryList: [], //行业列表
      showDetailDialog:false,
      difference:false,//是异常还是注销
      Title:'',
      rowData:[],
      listOptions:[],
      successCount:0,
      townCheckCount:0,
      countyCheckCount:0,
      // 已通过：1，待初审：4，待复审：8，驳回：5，异常：6，注销：7
      statusList:[
        {
          label:'已认证',
          status:1
        },
        {
          label:'待初审',
          status:4
        },
        {
          label:'待复审',
          status:8
        },
        {
          label:'驳回',
          status:5
        },
        {
          label:'异常',
          status:6
        },
        {
          label:'注销',
          status:7
        },
      ],
      roleCode:Cookies.get('roleCode')||""
    };
  },
  created() {
     let mode = this.$route.query.mode;
    if(mode=='unaudited'){
      if(this.roleCode==19){
        this.tims=3
         this.filterForm.status=8
     }else if(this.roleCode==21){
        this.tims=2
        this.filterForm.status=4
     }else{
      this.filterForm.status=""
      this.tims=4
     }
    };

    this.GLOBAL.eventBus.$on("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$on("firstLoadAreaOption", this.getNextXzqData); //
  },
  beforeDestroy() {
    this.GLOBAL.eventBus.$off("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$off("firstLoadAreaOption", this.getNextXzqData); //
  },
  mounted() {
    this.init();
  },
  methods: {
    formatterFn(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return cellValue;
    },
    formatterDate(row, column, cellValue, index) {
      console.log("cellValue",cellValue)
      if (!cellValue) {
        return "--";
      }
      return this.GLOBAL.timetoDate(Number(cellValue),'date') ;
    },
    /*页面初始化*/
    init() {
      this.getParams();
      this.getindustryTree();
      this.priseList();
      this.getNextXzqData();
      this.commonList();
      this.getcommonList()
    },
    //获取区域数据
    async getNextXzqData() {
      let regionOption = localStorage.getItem("areaOptions"); //获取乡级以上区域信息
      if (regionOption) {
        this.areaOptions = [JSON.parse(regionOption)];
      }
    },
    // 主体类型列表接口
    async commonList() {
      let { code, data } = await API.commonListApp({categoryNumber:'1003',appId:process.env.appId  });
      if (code === 0) {
        if (data && data.list && data.list.length) {
          this.industryOptions = data.list;

        }
      }
    },
    //获取经营类型
   async getindustryTree(){
      let { code, msg,data } = await API.industryTree();
      if (code === 0) {
        this.industryList =data.tree
      }

    },
    //主体等级
    async getcommonList(){
       let { code, msg,data } = await API.commonList({ code: 19 });
        if (code === 0) {
        if (data && data.list && data.list.length) {
          this.listOptions = data.list;
        }
      }
    },
    //  参数设置
    getParams() {
      let form = this.filterForm;
      if (!form.submitDate) {
            form.submitDate = []
          }

      this.params = {
        // 参数
        qhdm: form.qhdmValue[form.qhdmValue.length - 1],
        page: this.currentPage, // 页数
        enterpriseName: form.enterpriseName, // 主体名称
        enterpriseTypeNumber: form.enterpriseTypeNumber, // 主体类型
        industryDicNumber:
          form.industryDicNumber[form.industryDicNumber.length - 1], // 所属行业名称
        corporationName: form.contacts, // 法人姓名
        status: this.filterForm.status, // 审核状态
        gradeCode:this.filterForm.dicNumber,
        startTime: form.submitDate.length!=0 ? form.submitDate[0] : "", //开始时间
        endTime: form.submitDate.length!=0
          ? form.submitDate[1] + (1000 * 60 * 60 * 24 - 1000)
          : "", //结束时间
      };
    },
    //企业信息列表接口
    async priseList() {
      const { code, data } = await API.libraryList(this.params);
      if (code === 0) {
        this.totalItems = data.count;
        this.tableData = data.unauditeList;
        this.countyCheckCount=data.countyCheckCount
        this.successCount=data.successCount
        this.townCheckCount=data.townCheckCount
      }
    },
    //查询所属行业接口
    async managementTypeList() {
      let { code, list } = await API.managementTypeList();
      if (code === 0) {
        this.industryList = list
      }
    },
    //设备详情
    searchDialog(row) {
      // 审核通过
      // row.status=1
      if(row.status==1){
        this.ifAbnormal=true
        this.ifAudit=false
      }else if(row.status==4||row.status==8){
        // 待审核
        this.ifAbnormal=false
        this.ifAudit=true
      }else{
        // 其他状态
        this.ifAbnormal=false
        this.ifAudit=false
      }
      this.$refs.show_operator_dialog.dialogOpen(row);
    },
    /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val;
      this.params.page = val;
      this.priseList();
    },

    /*点击查询按钮*/
    queryBtnClick() {
      this.currentPage = 1;
      this.tims = 4
      this.getParams();
      this.priseList();
    },

    /*点击重置按钮*/
    resetFilter() {
      this.filterForm.page = this.currentPage = 1; // 页数
      this.filterForm.enterpriseName = ""; // 主体名称
      this.filterForm.enterpriseTypeNumber = ""; // 主体类型
      this.filterForm.industryDicNumber = ""; // 所属行业名称
      this.filterForm.contacts = ""; // 法人姓名
      this.filterForm.qhdmValue = [Cookies.get("curAreaCode")]; // 区域
      this.filterForm.submitDate = []; // 日期
      this.filterForm.status=''
      this.filterForm.dicNumber=""
      this.tims = 4
      this.getParams()
      this.priseList()
    },
    /*table选中行回调方法*/
    handleCurrentChange(val) {
      this.currentRow = val;
    },

    /*收起按钮*/
    pullup() {
      this.showQueryFilter = false;
    },

    /*展开按钮*/
    pulldown() {
      this.showQueryFilter = true;
    },
    //注销按钮
    cancellation(row){
      // 通过审核
      this.rowData = row
      this.difference=false
      this.showDetailDialog=true
    },
    // 异常按钮
    abnormal(row){
      this.rowData = row
      this.difference=true
       this.showDetailDialog=true

    },
    // 点击筛选
    clicktotalItems(index){
      this.tims=index
      if(index==2){
          this.filterForm.status=4
          this.getParams()
          this.priseList()
      }else if(index==3){
         this.filterForm.status=8
         this.getParams()
         this.priseList()
      }else if(index==1){
         this.filterForm.status=1
         this.getParams()
         this.priseList()
      }else{
        this.filterForm.status=""
         this.getParams()
         this.priseList()
      }
    },
    // chehui(){
    //   this.showDetailDialog=true
    // },
    determine(){
      if(this.difference==true){
        this.njbenterpriseUpdate({status:6,number:this.rowData.enterpriseNumber})
        ///异常
      }else{
        //注销
         this.njbenterpriseUpdate({status:7,number:this.rowData.enterpriseNumber})
      }
    },
    async njbenterpriseUpdate(val){
        const { code, data ,msg} = await API.njbenterpriseUpdate(val);
      if (code === 0) {
         this.$message({
          message: msg,
          type: 'success'
        });
        this.showDetailDialog=false
        this.priseList()
      }
    }
  },
};
</script>
<style lang="less">
el-dialog__header {
  background: red;
  text-align: center;
}
.dialog-footer{
  text-align: center;
}
.icon-zhuxiao{
  color: red;
}
.el-icon-warning-outline{
  color: #F89E01;

}
.template-slot-scope{
  // width: 100%;
  display: flex;
  align-items: center;
  // text-align: center;
  // justify-content: space-around;
}
.box_total{
  height: 50px;
  border: 1px solid #EEF0F3;
  width: 23%;
  margin: 10px;
  background: #FFFFFF;
  box-shadow: 0px 0px 44px 0px rgba(118,134,182,0.1400);
  border-radius: 5px;
   display: flex;
  justify-content: space-around;
  align-items: center;

}
.bg{
   border: 1px solid #2A8852;
   color: #2A8852;
}
</style>




// WEBPACK FOOTER //
// src/studio/subject/listOfLibrary/auditedList.vue